import { FileDto } from 'src/dto/file.dto'
import { FileService } from 'src/services/api/file.service'

export class FileController {
  private service: FileService

  constructor() {
    this.service = new FileService()
  }

  public async uploadFile(farmId: string, entity: string, referenceId: string, file: File): Promise<FileDto> {
    const response = await this.service.uploadFile(farmId, entity, referenceId, file)
    return response.data
  }

  public async listFiles(farmId: string, entity: string, referenceId: string): Promise<FileDto[]> {
    const response = await this.service.listFiles(farmId, entity, referenceId)
    return response.data.filter((file) => file.acao !== 'Removido')
  }

  public async getFile(farmId: string, entity: string, referenceId: string, fileId: string): Promise<Blob> {
    const response = await this.service.getFile(farmId, entity, referenceId, fileId)
    return response.data
  }

  public async deleteFile(farmId: string, entity: string, referenceId: string, file: FileDto): Promise<FileDto> {
    const response = await this.service.deleteFile(farmId, entity, referenceId, file)
    return response.data
  }
}
